export default "__VITE_ASSET__fce22986__"